// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"067bc059","393":"dc1cd217","401":"9ff5828d","964":"067bc059"}[chunkId] + ".chunk.css";
};